export default "__VITE_ASSET__DlsIWn3y__"